export default __webpack_public_path__ + "static/media/wordpairs_standard.49bcfbcb.svg";